import { defineStore } from 'pinia'
import type { WorkRecord, WorkCategoryRecord } from '~/types/datocms'

export interface WorkStoreState {
  allWorks: WorkRecord[]
  allWorksCount: number
  allCategories: WorkCategoryRecord[]
  isLoading: boolean
  isLoadingMore: boolean
  itemsPerPage: number
  isButtonVisible: boolean
  skipItems: number
  filteredBy: WorkCategoryRecord | null
}

export const useWorkStore = defineStore('WorkStore', {
  state: (): WorkStoreState => ({
    allWorks: [],
    allWorksCount: 0,
    allCategories: [],
    isLoading: true,
    isLoadingMore: false,
    itemsPerPage: 10,
    isButtonVisible: false,
    skipItems: 0,
    filteredBy: null
  }),
  getters: {
    getCategoryBySlug(state) {
      return (catSlug: string) => state.allCategories.find((cat) => cat.slug === catSlug) || null
    }
  },
  actions: {
    async fetchWorks(filter?: string) {
      this.setButtonVisibility(false)
      try {
        const { data } = await useWorks({
          variables: {
            first: this.itemsPerPage,
            skip: this.skipItems,
            allInCategory: filter as unknown as string[]
          }
        })

        this.allWorksCount = data._allWorksMeta.count

        const allWorksRes: WorkRecord[] = data.allWorks as WorkRecord[]

        if (allWorksRes.length > 0) {
          this.allWorks.push(...allWorksRes)
          this.skipItems += allWorksRes.length
        }
      } catch (error) {
        console.error(error)
      } finally {
        useTimeoutFn(() => {
          this.setLoading(false)
          this.setLoadingMore(false)
        }, 600)

        useTimeoutFn(() => {
          this.setButtonVisibility()
        }, 1000)
      }
    },
    pushCategories(payload: WorkStoreState['allCategories']) {
      this.allCategories = payload
    },
    pushFilter(category: WorkStoreState['filteredBy']) {
      this.filteredBy = category
    },
    setItemsPerPage(amount: number) {
      this.itemsPerPage = amount
    },
    setLoading(bool: boolean) {
      this.isLoading = bool
    },
    setLoadingMore(bool: boolean) {
      this.isLoadingMore = bool
    },
    setButtonVisibility(bool?: boolean) {
      this.isButtonVisible = bool ? bool : this.skipItems < this.allWorksCount
    },
    resetWorks() {
      this.allWorks = []
      this.allWorksCount = 0
      this.skipItems = 0
    }
  }
})
